<template>
  <div>
    <Row :gutter="6">
      <Col :span="24">
        <subject-info :model="model" @refresh="fetchData"></subject-info>
        <!-- <Card class="visit-item">
          <p slot="title" class="clearfix">
            <span>非定期访视表单</span>
          </p>
          <div v-for="global in globals" :key="global.id">
            <form-state :model="global"></form-state>
          </div>
        </Card> -->
      </Col>
      <Col :span="24" :style="{ 'margin-bottom': '20px' }">
        <Card class="visit-item" v-for="visit in visits" :key="visit.id" :body-style="{ padding: '10px 10px 20px', 'margin-bottom': '10px' }">
          <p slot="title" class="clearfix">
            <span>{{ visit.visit }}</span>
          </p>
          <Row>
            <Col :span="6" v-for="domain in groupDomains(visit.id)" :key="domain.id">
              <domain-state :model="domain"></domain-state>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  </div>
</template>

<script>
import { ViewSubject, ListDomainStates, ReviewSubject } from '@/api/subject'
import SubjectInfo from '@/components/subject/SubjectInfo'
import DomainState from '@/components/subject/DomainState'

export default {
  name: 'view-subject',
  data: () => ({
    model: null,
    visits: {},
    states: {},
    filename: __filename
  }),
  created: function () {
    this.fetchData()
  },
  components: {
    'subject-info': SubjectInfo,
    'domain-state': DomainState
  },
  methods: {
    fetchData: function () {
      const id = this.$route.params.subjid
      ViewSubject({ id: id }).then(async res => {
        this.model = res
        if (!res.reviewer) {
          this.reviewSubject(id)
        } else {
          this.listStates()
        }
      })
    },
    listStates: function () {
      const query = { batch: this.$route.query.batch }
      ListDomainStates(this.$route.params.subjid, query).then(async res => {
        this.states = res.states
        this.visits = res.visits
      })
    },
    groupDomains: function (visitid) {
      return this.states.filter(function (item) {
        if (visitid === item.visitid) {
          return item
        }
      })
    },
    reviewSubject: function (id) {
      ReviewSubject(id).then(async res => {
        this.listStates()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
